import { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./styles.scss";

const useScrollToLocation = () => {
  const scrolledRef = useRef(false);
  const { hash } = useLocation();
  const hashRef = useRef(hash);

  useEffect(() => {
    if (hash) {
      // We want to reset if the hash has changed
      if (hashRef.current !== hash) {
        hashRef.current = hash;
        scrolledRef.current = false;
      }

      // only attempt to scroll if we haven't yet (this could have just reset above if hash changed)
      if (!scrolledRef.current) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          scrolledRef.current = true;
        }
      }
    } else {
      // window.scrollTo(0, 0)
    }
  });
};

const Connect = () => {
  useScrollToLocation();

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="connect">
      <section className="hero-wrap">
        <div className="container">
          <div className="content d-flex justify-content-center align-items-center">
            <div className="col-md-8 text-center">
              <h1>Connect with your branch pastors one-on-one</h1>
              <p>
                We would love to connect with you beyond Sundays and be a part
                of your journey.
                {/* Schedule a One-on-One with Your Local Pastor */}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about section black" id="cell-church">
        {/* <div className="container">
          <div className="row content flex-row-reverses justify-content-center align-items-center">
            <div className="col-md-12">
              <h2
                data-aos="fade-up"
                data-aos-duration="600"
                className="text-center text-white mb-4"
              >
                Book a time slot with your pastor
              </h2>
            </div>
          </div>
        </div> */}
        <div className="container">
          <div className="slider-containers row">
            {/* <Slider {...settings}> */}
            {pastors.map((item: any, index: any) => {
              return (
                <div className="col-md-3">
                  <div
                    className="cards pastor-card mb-4"
                    key={index}
                    data-aos="fade-up"
                    data-aos-duration="600"
                  >
                    <div className="cont">
                      <img
                        alt={item.name}
                        src={item?.image}
                        className="img-fluid"
                      />
                      <div className="inner">
                        <h4>{item.name}</h4>
                        <p>
                          <i className="fa-solid fa-map-pin mr-1"></i>{" "}
                          <b>{item.role} at</b> {item.city}
                        </p>
                        <Link
                          to={item.calendly}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <button className="btn instagram-btn w-full">
                            Schedule a meeting
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {/* </Slider> */}
          </div>
        </div>
      </section>

      <section className="cta section" id="contact">
        <div className="container">
          <div className="row content justify-content-center align-items-center">
            <div className="content">
              <h1 data-aos="fade-up" data-aos-duration="600">
                Want to Get more connected?
              </h1>
              <p data-aos="fade-up" data-aos-duration="600">
                <i className="fa-solid fa-chevron-right mr-1"></i> Learn more
                about our ministry at{" "}
                <a rel="noreferrer" target="_blank" href="https://joincci.org">
                  joincci.org
                </a>
              </p>
              <p data-aos="fade-up" data-aos-duration="600">
                <i className="fa-solid fa-chevron-right mr-1"></i> Want to have
                a one-on-one meeting with a Pastor?{" "}
                <Link to="/connect">Book a time slot</Link>
              </p>
              <p data-aos="fade-up" data-aos-duration="600">
                <i className="fa-solid fa-chevron-right mr-1"></i> Have
                questions? Send an email to{" "}
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="mailto:info.usa@joincci.org"
                >
                  info.usa@joincci.org
                </a>
              </p>
              <p data-aos="fade-up" data-aos-duration="600">
                <i className="fa-solid fa-chevron-right mr-1"></i> Want to
                partner with us? Give via this link{" "}
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://bit.ly/GiveCCIUSA"
                >
                  bit.ly/GiveCCIUSA
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Connect;

const pastors: any = [
  {
    name: "Opeyemi Olokede",
    city: "Dallas",
    country: "USA",
    role: "Resident Pastor",
    calendly:
      "https://calendly.com/celebrationchurchdallas/catching-up-with-po",
    image: require("../../assets/images/pastors/Opeyemi Olokede.jpg"),
  },
  {
    name: "Ernest Olusanya",
    city: "DMV",
    country: "USA",
    role: "Resident Pastor",
    calendly: "https://calendly.com/meetwithpeld/40",
    image: require("../../assets/images/pastors/Ernest Olusanya.jpg"),
  },
  {
    name: "Damilola Akinneye",
    city: "Dallas",
    country: "USA",
    role: "Pastor",
    calendly: "https://calendly.com/dammy-akinneye/30min",
    image: require("../../assets/images/pastors/Damilola Akinneye.jpg"),
  },
  {
    name: "Damilola Akinneye (PLD)",
    city: "Dallas",
    country: "USA",
    role: "Pastor",
    calendly: "https://calendly.com/dammieolojede/30min",
    image: require("../../assets/images/pastors/Damilola Akinneye (PLD).jpg"),
  },
];
